export default __webpack_public_path__ + "static/media/office1-before2-1440w.ab645d63.webp";